/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Browsersupport1Inputs */

const id_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukungan Browser:`)
};

const ms_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sokongan Pelayar:`)
};

const da_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser Support:`)
};

const de_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser-Unterstützung:`)
};

const en_us2_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser Support:`)
};

const es_es2_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibilidad de navegadores:`)
};

const es_mx2_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibilidad de navegadores:`)
};

const fil_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporta sa Browser:`)
};

const fr_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigateurs pris en charge :`)
};

const it_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporto browser:`)
};

const hu_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böngésző támogatás:`)
};

const nl_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browserondersteuning:`)
};

const no_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettleserstøtte:`)
};

const pl_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsługa przeglądarek:`)
};

const pt_br2_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporte ao navegador:`)
};

const pt_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporte de navegadores:`)
};

const ro_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suport browser:`)
};

const fi_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selaintuki:`)
};

const sv_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webbläsarstöd:`)
};

const vi_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hỗ trợ trình duyệt:`)
};

const tr_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarayıcı Desteği:`)
};

const cs_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podpora prohlížečů:`)
};

const bg_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддръжка на браузъри:`)
};

const ru_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержка браузеров:`)
};

const uk_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтримка браузерів:`)
};

const ar_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعم المتصفح:`)
};

const hi_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्राउज़र समर्थन:`)
};

const th_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสนับสนุนเบราว์เซอร์:`)
};

const ja_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザサポート：`)
};

const zh_cn2_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器支持：`)
};

const zh_hant1_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`瀏覽器支援：`)
};

const ko_notifications_browsersupport1 = /** @type {(inputs: Notifications_Browsersupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브라우저 지원:`)
};

/**
* | output |
* | --- |
* | "Browser Support:" |
*
* @param {Notifications_Browsersupport1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_browsersupport1 = /** @type {((inputs?: Notifications_Browsersupport1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Browsersupport1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_browsersupport1(inputs)
	if (locale === "ms") return ms_notifications_browsersupport1(inputs)
	if (locale === "da") return da_notifications_browsersupport1(inputs)
	if (locale === "de") return de_notifications_browsersupport1(inputs)
	if (locale === "en-US") return en_us2_notifications_browsersupport1(inputs)
	if (locale === "es-ES") return es_es2_notifications_browsersupport1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_browsersupport1(inputs)
	if (locale === "fil") return fil_notifications_browsersupport1(inputs)
	if (locale === "fr") return fr_notifications_browsersupport1(inputs)
	if (locale === "it") return it_notifications_browsersupport1(inputs)
	if (locale === "hu") return hu_notifications_browsersupport1(inputs)
	if (locale === "nl") return nl_notifications_browsersupport1(inputs)
	if (locale === "no") return no_notifications_browsersupport1(inputs)
	if (locale === "pl") return pl_notifications_browsersupport1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_browsersupport1(inputs)
	if (locale === "pt") return pt_notifications_browsersupport1(inputs)
	if (locale === "ro") return ro_notifications_browsersupport1(inputs)
	if (locale === "fi") return fi_notifications_browsersupport1(inputs)
	if (locale === "sv") return sv_notifications_browsersupport1(inputs)
	if (locale === "vi") return vi_notifications_browsersupport1(inputs)
	if (locale === "tr") return tr_notifications_browsersupport1(inputs)
	if (locale === "cs") return cs_notifications_browsersupport1(inputs)
	if (locale === "bg") return bg_notifications_browsersupport1(inputs)
	if (locale === "ru") return ru_notifications_browsersupport1(inputs)
	if (locale === "uk") return uk_notifications_browsersupport1(inputs)
	if (locale === "ar") return ar_notifications_browsersupport1(inputs)
	if (locale === "hi") return hi_notifications_browsersupport1(inputs)
	if (locale === "th") return th_notifications_browsersupport1(inputs)
	if (locale === "ja") return ja_notifications_browsersupport1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_browsersupport1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_browsersupport1(inputs)
	return ko_notifications_browsersupport1(inputs)
});
export { notifications_browsersupport1 as "notifications.browserSupport" }